module.exports = __webpack_public_path__ + "media/images/icon_star1-318ae99d2df2778f0f41189cb2319ec1.svg";